export default "__VITE_ASSET__23df7b46__"